import { useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { doc, updateDoc } from 'firebase/firestore';
//@ts-ignore
import { db } from '../../utils/firebase.js';

const EditUserWhatsApp = () => {
  const [formData, setFormData] = useState({
    email: '',
    whatsappNumber: '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    //console.log('Edit WhatsApp Data Submitted:', formData);

    if (!formData.email || !formData.whatsappNumber) {
      toast.error('Email and WhatsApp Number are required!');
      return;
    }

    // Validate WhatsApp Number: exactly 12 digits
    const whatsappRegex = /^\d{12}$/;
    if (!whatsappRegex.test(formData.whatsappNumber)) {
      toast.error('WhatsApp Number must be exactly 12 digits (no spaces or special characters).');
      return;
    }

    try {
      const userDocRef = doc(db, 'userDetails', formData.email);
      await updateDoc(userDocRef, {
        whatsappNumber: formData.whatsappNumber,
      });

      toast.success('WhatsApp Number updated successfully!');

      setFormData({
        email: '',
        whatsappNumber: '',
      });

    } catch (error: any) {
      console.error('Error updating WhatsApp Number:', error);
      toast.error('The email is not registered with our business, please register user first');
      setFormData({
        email: '',
        whatsappNumber: '',
      });
    }
  };

  return (
    <div className="max-w-2xl bg-white rounded-lg shadow p-4 lg:p-6">
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
      <h2 className="text-xl font-bold mb-6">Edit User WhatsApp Number</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        {/* Email */}
        <div>
          <label className="block text-sm font-medium text-gray-700">Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
          />
        </div>

        {/* WhatsApp Number */}
        <div>
          <label className="block text-sm font-medium text-gray-700">WhatsApp Number</label>
          <input
            type="text"
            name="whatsappNumber"
            value={formData.whatsappNumber}
            onChange={handleChange}
            maxLength={12}
            className="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500 outline-none"
            placeholder="Enter 12-digit WhatsApp Number"
          />
        </div>

        {/* Update Button */}
        <div>
          <button
            type="submit"
            className="w-full bg-[#0b3a28] text-white px-6 py-2 rounded-lg hover:bg-[#1c2822]"
          >
            Update WhatsApp Number
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditUserWhatsApp;
